export interface TabOption {
  value: string | number;
  label: string;
}

export interface TabSelectorProps {
  options: TabOption[];
  value: string | number;
  onChange: (value: string | number) => void;
  className?: string;
}

export const TabSelector = ({ options, value, onChange, className = '' }: TabSelectorProps) => {
  return (
    <div className={`flex gap-2 border-b border-gray-200 ${className}`}>
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={`px-4 py-2 font-medium text-sm transition-colors ${value === option.value
            ? 'text-blue-600 border-b-2 border-blue-600'
            : 'text-gray-600 hover:text-gray-800'
            }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
